<app-grid class="show margin-left-20 margin-right-24 gridDisplayStatus" [columns]="gridColumnDefs" [data]="gridDetails" [gridConfigItems]="gridConfigItems" 
          [showKebabIcon]="false" [showHeader]="false">
</app-grid>
